/** Display metadata for language switcher (flag + short label). */
export const LOCALE_FLAG_META = {
  fa: {
    flag: '🇮🇷',
    label: 'فارسی',
    shortLabel: 'FA',
  },
  ckb: {
    flag: '☀️',
    label: 'کوردی',
    shortLabel: 'CKB',
    flagClass: 'is-kurdistan',
  },
  en: {
    flag: '🇬🇧',
    label: 'English',
    shortLabel: 'EN',
  },
};

export const getLocaleFlagMeta = (locale) => {
  const code = locale?.code || locale;
  const preset = LOCALE_FLAG_META[code] || {};
  return {
    flag: preset.flag || '🌐',
    label: locale?.nativeName || preset.label || code,
    shortLabel: preset.shortLabel || String(code || '').toUpperCase(),
    flagClass: preset.flagClass || '',
  };
};
